interface ComputerWithCarSVGProps {
  color: string;
  style: React.CSSProperties;
}

const ComputerWithCarSVG = ({ color, style }: ComputerWithCarSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="58"
    height="50"
    viewBox="0 0 58 50"
    fill="none"
  >
    <g clipPath="url(#clip0_465_7589)">
      <path
        d="M37.3066 0.555786H40.2741C42.0208 0.555786 43.4301 1.96508 43.4301 3.7118V11.8499"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.3066 0.555786H4.21803C2.4713 0.555786 1.06201 1.96508 1.06201 3.7118V28.8507C1.06201 30.5975 2.4713 32.0068 4.21803 32.0068H40.274C42.0207 32.0068 43.43 30.5975 43.43 28.8507V25.5161"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4436 32.0067L9.5083 36.8797H22.2415H34.9748L33.0494 32.0067"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.0559 40.5717L43.7379 47.2211C44.2937 48.2235 43.5692 49.4442 42.4278 49.4442H2.05468C0.91335 49.4442 0.188856 48.2136 0.744632 47.2211L4.42665 40.5717H40.0559Z"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.072 19.2338C26.072 20.266 25.8537 21.2386 25.4468 22.1219"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.0723 19.2338C26.0723 15.8099 23.2835 13.0111 19.8496 13.0111H13.478V19.2338H16.0187"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.8494 23.0647C21.9652 23.0647 23.6803 21.3496 23.6803 19.2338C23.6803 17.1181 21.9652 15.403 19.8494 15.403C17.7337 15.403 16.0186 17.1181 16.0186 19.2338C16.0186 21.3496 17.7337 23.0647 19.8494 23.0647Z"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.2586 15.403C48.3726 15.403 50.0895 17.1199 50.0895 19.2338C50.0895 21.3478 48.3726 23.0647 46.2586 23.0647C44.1447 23.0647 42.4277 21.3478 42.4277 19.2338C42.4277 18.6681 42.5468 18.1421 42.7652 17.6558"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.4468 22.1219H41.5345"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0898 13.2592L31.9179 9.49783H36.5924V15.403"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.9031 16.0481C52.8384 16.4947 54.9623 17.2589 56.6197 18.5491C57.106 18.9262 57.4037 19.5117 57.4037 20.137C57.4037 21.2386 56.5105 22.1318 55.4089 22.1318H50.8237"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.6177 15.403H46.2588"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4106 19.2338C18.4106 18.4399 19.0557 17.7948 19.8497 17.7948C20.6437 17.7948 21.2888 18.4399 21.2888 19.2338"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M44.8198 19.2338C44.8198 18.4399 45.4649 17.7948 46.2589 17.7948C47.0529 17.7948 47.698 18.4399 47.698 19.2338"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.5923 10.9071C36.5923 10.9071 40.1354 11.2644 40.1354 15.403"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.599 23.0647H4.63477"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4605 19.2338H4.63477"
        stroke={color}
        strokeWidth="1.11155"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_465_7589">
        <rect width="57.9496" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default ComputerWithCarSVG;
